<form [formGroup]="filterForm" id="formFilter" (ngSubmit)="onSubmit()">
  <mat-list-item>
    <mat-form-field fxFlex>
      <input matInput cdkFocusInitial  formControlName="inputData" [placeholder]="filter.options.placeHolder | translate" required>
    </mat-form-field>
  </mat-list-item>
</form>
